// import React, { Component } from 'react';
// import _, { isEmpty, get } from 'lodash';
// import routes from "../../../../../../routes";
// import { handleFieldError, initializeForm, handleError } from "../../../../../../utils/form-validation";
// import { ionFormFileds } from "./constant";
// import { connect } from 'react-redux';
// import Input from '../../../../../../components/FormElements/Input';

// class index extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       form: {},
//       touched: {},
//       errors: {},
//       form: {},
//       touched: {},
//       errors: {},
//       editMode: false,
//       submited: false,
//       ionAds: [{ ionAionAccountIDccountID: "", ionCurrency: "", errors: {}, touched: {} }],
//     };
//   }

//   componentWillReceiveProps(nextProps) {
//     if (nextProps.checkFields != "") {
//       this.checkFormFields();
//     }
//   }

//   componentWillMount() {
//     let isAuthenticated = JSON.parse(localStorage.getItem('AuthData'));
//     if (isEmpty(isAuthenticated)) {
//       const { history } = this.props;
//       history.push(routes.preSignIn);
//     }
//     const { form, errors } = initializeForm(ionFormFileds);

//     this.setState({ form, errors }, () => {
//       this.editId();
//     });
//   }

//   handleChange = (e, index) => {
//     let { form, ionAds } = this.state;
//     const { handleCallback } = this.props;
//     let { value, name } = e.target;
//     form[name] = value;
//     this.setState({ form });

//     const list = [...ionAds];
//     list[index][name] = value;
//     this.setState({ ionAds: list });

//     var obj = "";
//     ionAds.forEach((item => {
//       obj = !Object.values(item).some((x) => x == "")
//     }))

//     if (obj) {
//       handleCallback(ionAds);
//     }
//   }

//   handleTouch = (e, index) => {
//     let { ionAds } = this.state;
//     let { error } = handleFieldError(ionAds[index][e.target.name], ionFormFileds[e.target.name]);
//     ionAds[index].errors[e.target.name] = error;
//     ionAds[index].touched[e.target.name] = true;
//     this.setState({ ionAds });
//   };

//   // ========== google ads start =============
//   handleRemoveClick = index => {
//     const list = [...this.state.ionAds];
//     list.splice(index, 1);
//     this.setState({ ionAds: list });
//   };

//   handleAddClick = () => {
//     this.setState({ ionAds: [...this.state.ionAds, { ionAccountID: "", ionCurrency: "", errors: {}, touched: {} }] });
//   };

//   renderIONValue = () => {
//     let ionAds = this.state.ionAds;
//     const { confirmationOpen, confirmationInfo, submited, errors, touched, form, editMode } = this.state;
//     let ionAdsValue = ionAds.map((ionAdsList, index) => {
//       return (
//         <div className='ml-5'>
//           <h5>ION Account {index + 1} :</h5>
//           <div className='ml-5'>
//             <Input
//               onChange={(e) => this.handleChange(e, index)}
//               onBlur={(e) => this.handleTouch(e, index)}
//               value={ionAdsList.ionAccountID}
//               setting={ionFormFileds[ionFormFileds.ionAccountID.key]}
//               error={ionAdsList.errors[ionFormFileds.ionAccountID.key]}
//               submited={submited}
//               touched={ionAdsList.touched[ionFormFileds.ionAccountID.key]}
//             />
//           </div>
//           <div className='ml-5 removeML'>
//             <Input
//               onChange={(e) => this.handleChange(e, index)}
//               onBlur={(e) => this.handleTouch(e, index)}
//               value={ionAdsList.ionCurrency}
//               setting={ionFormFileds[ionFormFileds.ionCurrency.key]}
//               error={ionAdsList.errors[ionFormFileds.ionCurrency.key]}
//               submited={submited}
//               touched={ionAdsList.touched[ionFormFileds.ionCurrency.key]}
//             />
//             <button className="btn-remove-io" onClick={() => this.handleRemoveClick(index)}><i className='mdi mdi-delete'></i></button>
//           </div>
//         </div>
//       )
//     })
//     return ionAdsValue;
//   };

//   checkFormFields = () => {
//     const { checkFields, handleCallback } = this.props;
//     const { errors, ionAds } = this.state;
//     var ionCheck = this.handleIONError();
//     if (ionCheck) {
//       handleCallback(ionAds);
//     }
//     this.setState({ errors: errors, submited: true });
//   }

//   handleIONError = () => {
//     const { ionAds } = this.state;
//     let ionCheck = true;

//     ionAds.forEach((item) => {
//       const { errors, valid } = handleError(item, ionFormFileds);
//       item.errors = errors;
//       if (!ionCheck || !valid) {
//         ionCheck = false;
//       } else if (ionCheck && valid) {
//         ionCheck = true;
//       }
//     });

//     this.setState({ ionAds });
//     return ionCheck;
//   }

//   editId = () => {
//     const { ionEditData, props: { match: { params: { id } } }, handleCallback } = this.props;
//     const { ionAds } = this.state;

//     if (id) {
//       let ionAdsData = ionEditData.map(item => {
//         return { ionAccountID: item.accountId, ionCurrency: item.currency, errors: {}, touched: {} }
//       })
//       this.setState({ ionAds: ionAdsData }, () => {
//         handleCallback(ionAds);
//       })
//     }
//   }

//   render() {
//     return (
//       <>
//         <div className='main-class-wrap text-left'>
//           <this.renderIONValue />
//           <button className='btn-add-io' onClick={() => this.handleAddClick(index)}><i className="mdi mdi-plus"></i> Add Google Platform</button>
//         </div>
//       </>
//     );
//   }
// }

// export default connect(
//   state => ({})
// )(index);



import React, { Component } from 'react';
import MySelect from "../../../../../../components/CheckboxSelect";
import { postIonCampaignAction,postDV360VerificationAction, postDv360AccountsAction, postDv360CampaignAction, postSyncCampaignAction, getGenrateAccountIdDV360Action, getUserInformationAction, createAdvertiserAction, getDv360UrlAction, deleteAccountsAction, postSyncCampaignDV360Action } from "../../../../../../actions";
import { connect } from 'react-redux';
import ReactSelect from "react-select";
import _, { isEmpty, get } from 'lodash';
import ToastModal from "../../../../../../components/ToastModal";
import routes from "../../../../../../routes";
import { withRouter } from 'react-router-dom';
import { formFields } from "./constant";
import Input from "../../../../../../components/FormElements/Input";
import { useId } from 'react';
import { infomoSeatTenantToken } from '../../../../../../constants/configuration';
import { getTenantCountry } from '../../../../../../selectors';

class index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ionAds: [{ optionSelected: [], status: false, masterAccounts: [], masterDisabled: false, accToggle: false, campaignToggle: false, fetchAccount: [], accountDisabled: false, campaignDetailsList: {}, campaignSelected: [], sync: false }],
      masterAccountToogle: false,
      accToggle: false,
      campaignToggle: false,
      masterAccounts: [],
      accountIds: [],
      cardStatus: false,
      fetchAccount: [],
      accountSelected: [],
      campaignDetails: {},
      campaignPayload: [],
      accountDisabled: false,
      masterDisabled: false,
      enableToast: false,
      toastStatus: "",
      toastMsg: "",
      confirmationMsg: "",
      res: [],
      campaignDetailsList: [],
      redirectToList: false,
      isReloadPage: false
    }
  }

  async componentWillMount() {
    const { paths, editId } = this.props;
    const { history, match } = paths;

    // if ((window.location.href != `${window.location.origin}/atd/admin/advertiser-list/edit-advertiser`)) {
    //   localStorage.setItem("dvUrl", JSON.stringify(window.location.href));
    //   if (localStorage.getItem("dvUrl")) {
    //     history.push(`${match.path}`)
    //   }
    // }

    // setTimeout(() => {
    //   let url = JSON.parse(localStorage.getItem("dvUrl"));
    //   if (url && !url.includes("access_denied" && url.includes('display-video'))) {
    //     this.handleVerification(url);
    //   }
    // }, 1000)

    if (JSON.parse(localStorage.getItem("syncId"))) {
      this.handleCampaigns();
    }

    if (editId) {
      this.editId(editId);
    }
  }

  // =========== get Google file url =============
  handleGenerateUrl = async (index) => {
    const { getDv360UrlAction, tenantId } = this.props;
    const { ionAds } = this.state;
    localStorage.setItem("loginClicked", JSON.stringify(true));
    let localUrl = localStorage.getItem("dvUrl");

    if (localUrl == null) {
      const { responseCode: { status = "" }, response: { platform, url } } = await getDv360UrlAction({ callbackUrl: window.location.href, tenantId });
      if (status == "Success") {
        ionAds.forEach(item => {
          item.status = true;
        })
        localStorage.setItem("ionAds", JSON.stringify(ionAds))
        window.location.href = url;
      }
    } else if (localUrl != null) {
      if (localUrl.includes("access_denied")) {
        const { responseCode: { status = "" }, response: { platform, url } } = await getDv360UrlAction({ callbackUrl: window.location.href, tenantId });
        if (status == "Success") {
          window.location.href = url;
        } else {
          localStorage.removeItem("advertiserPlatform");
          localStorage.removeItem("addType");
        }
      }
    }
  }

  // ========== dv360 edit data ==========
  editId = () => {
    const { dvEditData } = this.props;
    if (dvEditData) {
      let ionAds = dvEditData.map(item => {
        return {
          optionSelected: [],
          status: true,
          masterAccounts: [],
          masterDisabled: false,
          accToggle: false,
          campaignToggle: false,
          fetchAccount: [],
          accountDisabled: false,
          campaignDetailsList: {},
          campaignSelected: [],
          isInfomo: item.isInfomo,
          sync: true,
          masterAccountId: item.masterAccountId,
          accountId: item.accountId,
          currency: item.currency
        }
      })

      this.setState({ ionAds });
    }
  }

  // ======== google verification ========
  handleVerification = async (url) => {
    let editId = JSON.parse(localStorage.getItem("editId"));
    var splitUrl = url.split("code=");
    let payload = {
      url: splitUrl[1],
      callbackUrl: window.location.href,
      advId: editId
    }

    const { postDV360VerificationAction, tenantId, userId, authToken } = this.props;
    const { responseCode: { status = "" }, responseList } = await postDV360VerificationAction({ tenantId, userId, authToken, payload });

    if (status == "Success") {
      localStorage.removeItem("dvUrl");
      const masterAccountList = responseList.map(mcc => {
        return { value: mcc.name, label: mcc.name, id: mcc.id, email: mcc.email, refreshToken: mcc.refreshToken, isMasterNew: mcc.isMasterNew, currency: mcc.currency, partner: mcc.partner }
      });

      this.setState({ masterAccounts: masterAccountList }, () => {
        this.selectedValue();
      });

    } else {
      localStorage.removeItem("dvUrl");
      localStorage.removeItem("advertiserPlatform");
      localStorage.removeItem("addType");
      localStorage.removeItem("loginClicked");
    }
  }

  selectedValue = () => {
    const { masterAccounts, ionAds } = this.state;
    var selectedGoogleAdsData = JSON.parse(localStorage.getItem("ionAds"));

    selectedGoogleAdsData.forEach(item => {
      if (item.masterAccounts.length === 0) {
        item.masterAccounts = masterAccounts;
      }
    })

    this.setState({ ionAds: selectedGoogleAdsData, masterAccounts: masterAccounts, masterAccountToogle: true });
  }

  // ========== remove google adwords account ========


  handleRemoveClick = async (index) => {
    const { ionAds } = this.state;
    const list = [...ionAds];
    list.splice(index, 1);
    this.setState({ ionAds: list });

  };
  handleRemoveAccounts = async (index, accountId) => {

    this.setState({ isReloadPage: true, enableToast: true, accountIdForDelete: accountId, indexForDelete: index, toastStatus: "confirmation", confirmationMsg: 'Kindly confirm the deletion of this record. This action cannot be undone.' });
  };

  // ========== add new google adwords account ========
  handleAddClick = () => {
    this.setState({ ionAds: [...this.state.ionAds, { optionSelected: [], status: false, masterAccounts: [], masterDisabled: false, accToggle: false, campaignToggle: false, fetchAccount: [], accountDisabled: false, campaignSelected: [] }] });
  };

  // ======== fetch all account =========
  handleFetchAccount = async (index) => {
    let editId = JSON.parse(localStorage.getItem("editId"));
    const { accountIds, ionAds } = this.state;
    const { postDv360AccountsAction, tenantId, userId, authToken } = this.props;
    let payload = {
      clientPartner: accountIds,
      advId: editId
    }

    if (accountIds.length > 0) {
      const { responseCode: { status = "" }, responseList } = await postDv360AccountsAction({ tenantId, userId, authToken, payload });

      if (status === "Success") {
        let res = responseList.map(res => {
          return { customerId: res.customerId, masterId: res.masterId, manager: res.manager, label: res.name, value: res.name, currencyCode: res.currencyCode, isNew: res.isNew, isMasterNew: res.isMasterNew, refreshToken: res.refreshToken }
        })

        ionAds[index].masterDisabled = true;
        ionAds[index].accToggle = true;
        ionAds[index].fetchAccount = res;

        this.setState({ ionAds });
      }
    } else {
      this.setState({ enableToast: true, confirmationMsg: "Please Select A Master Account.", toastMsg: "", toastStatus: "required" });
    }
  }

  // =========== btn toggle =========
  toggle = (event, index, ionList) => {
    const { id } = event.target;
    if (id == "master-account") {
      this.handleFetchAccount(index, ionList);
    } else if (id == "account-list") {
      this.handleCampaigns(index, ionList);
    } else if (id == "exit-screen") {
      this.handleSyncCampaign();
    } else {
      this.setState({ campaignToggle: false })
    }
  }

  // ========= campaign list ===========
  handleCampaigns = async (index, ionList) => {
    let editId = JSON.parse(localStorage.getItem("editId"));

    const { fetchAccount, accountSelected, ionAds } = this.state;
    const { postDv360CampaignAction, loginStatus, googleEditData, tenantId, userId, authToken } = this.props;

    let obj = {
      name: ionList.accountSelected.value,
      customerId: ionList.accountSelected.customerId,
      masterId: ionList.accountSelected.masterId,
      manager: ionList.accountSelected.manager,
      currencyCode: ionList.accountSelected.currencyCode,
      isNew: ionList.accountSelected.isNew,
      isMasterNew: ionList.accountSelected.isMasterNew,
      refreshToken: ionList.accountSelected.refreshToken,
      advId: editId
    }

    var payload = {
      clientPartner: [obj],
    }

    if (payload.clientPartner.length > 0) {
      const { responseCode: { status = "" }, responseList } = await postDv360CampaignAction({ tenantId, userId, authToken, payload });
      if (status == "Success") {

        this.setState({ res: responseList });

        let res = responseList[0].campaignDetails.map(camp => {
          return { label: camp.displayName, value: camp.displayName, name: camp.displayName, isActive: camp.isActive, isCampaignNew: camp.isCampaignNew, campaignId: camp.campaignId, entityStatus: camp.entityStatus, advertiserId: camp.advertiserId }
        })

        let obj = {
          customerId: responseList[0].customerId, masterId: responseList[0].masterId, currencyCode: responseList[0].currencyCode, isNew: 0, isMasterNew: 0, refreshToken: responseList[0].refreshToken, email: responseList[0].email, campaignDetails: res, advId: editId
        }
        if (!loginStatus) {
          ionAds[index].campaignToggle = true;
          ionAds[index].accountDisabled = true;
        }

        ionAds[index].campaignDetailsList = obj;
        this.setState({ campaignDetails: obj })
      }
    } else {
      this.setState({ enableToast: true, confirmationMsg: "Please Select A Account.", toastMsg: "", toastStatus: "required" });
    }
  }

  // ======= get information =========
  getAllData = async () => {
    const { getUserInformationAction, tenantId } = this.props;
    const { responseCode: { status = "" }, responseList } = await getUserInformationAction({ tenantId })
    if (status === "Success") {
      this.setState({ userInfo: responseList })
    }
  }

  // ========== sync campaign =======
  handleSyncCampaign = async () => {
    let editId = JSON.parse(localStorage.getItem("editId"));
    const { campaignDetails, campaignPayload, res, ionAds } = this.state;

    const { postSyncCampaignDV360Action, tenantId, toast, userId, authToken } = this.props;
    campaignDetails.campaignDetails = campaignPayload;

    let payload = {
      clientPartner: [campaignDetails]
    }

    if (campaignPayload.length > 0) {
      const { responseCode: { status = "", msg = "" } } = await postSyncCampaignDV360Action({ tenantId, userId, authToken, payload });
      if (status == "Success") {
        this.setState({ redirectToList: true })
        this.toast(status, msg, true);
      }
    } else {
      this.setState({ enableToast: true, confirmationMsg: "Please select a campaign.", toastMsg: "", toastStatus: "required" });
    }
  }



  async infoGenrateAccountID() {
    let editId = JSON.parse(localStorage.getItem("editId"));
    const { tenantId, authToken, userId, postIonCampaignAction, history, match,advId } =  this.props;
   
    let advCountry = getTenantCountry(advId);

    let ionLoginData = {
      // tenantToken: infomoSeatTenantToken,
      advId: advId,
      isSync : 0,
      isInfomo : 1,
      country: advCountry,
    }





      if (ionLoginData) {
        const { responseCode: { status = "",msg }, response } = await postIonCampaignAction({ tenantId, authToken, userId, payload:ionLoginData });
        console.log("response", response);
  
        if (status == "Success") {
          this.setState({ redirectToList: true });
          this.toast(status, msg, true);
        }
        else{
        this.toast(status, msg, true,true);
        }
      } 
    // const {
    //   responseCode: { status = "", msg = "" },
    //   // responseList,
    // } = await getGenrateAccountIdDV360Action({
    //   tenantId,
    //   authToken,
    //   userId,
    //   payload

    // });

    // if (status) {
    //   this.setState({ redirectToList: true });
    //   this.toast(status, msg, true);
    // }

  }

  // ========== onChange ========
  handleSelectChange = (selected, index, name) => {
    if (name === "master-account") {
      let accountId = [];
      selected.isMasterNew = 0;

      let obj = {
        name: selected.value,
        id: selected.id,
        partner: selected.partner,
        email: selected.email,
        refreshToken: selected.refreshToken,
        isMasterNew: selected.isMasterNew,
        currency: selected.currency
      }

      accountId.push(obj);

      const { ionAds } = this.state;
      ionAds[index].optionSelected = selected;
      this.setState({ ionAds, accountIds: accountId });

    } else if (name === "accounts") {
      let accounts = [];
      selected.isMasterNew = 0;
      selected.isNew = 0;

      let obj = { customerId: selected.customerId, masterId: selected.masterId, currencyCode: selected.currencyCode, isNew: selected.isNew, isMasterNew: selected.isMasterNew, refreshToken: selected.refreshToken, email: selected.email }

      accounts.push(obj);

      const { ionAds } = this.state;
      ionAds[index].accountSelected = selected;
      this.setState({ ionAds, accountSelected: accounts });

    } else if (name === "campaigns") {
      const { ionAds } = this.state;
      ionAds[index].campaignSelected = selected;
      this.setState({ ionAds });

      let changeSelectedData = selected.map(sel => {
        return { displayName: sel.name, isCampaignNew: 0, campaignId: sel.campaignId, entityStatus: sel.entityStatus, advertiserId: sel.advertiserId }
      })

      this.setState({ campaignPayload: changeSelectedData })
    }
  };

  toast = (status, msg) => {
    this.setState({ enableToast: true, toastStatus: status, toastMsg: msg });
    return;
  }

  deleteRecord = async () => {

    const { tenantId, authToken, userId, deleteAccountsAction } = this.props;
    const { accountIdForDelete, indexForDelete } = this.state;
    const { responseCode: { status = "", msg }, responseList } = await deleteAccountsAction({ tenantId, authToken, userId, accountId: accountIdForDelete });
    if (status == "Success") {
      const { ionAds } = this.state;
      const list = [...ionAds];
      list.splice(indexForDelete, 1);
      this.setState({ ionAds: list });
      window.location.reload();
    }
    else if (status.toLowerCase() == 'fail') {
      let toastStatus = "error";
      let msgStr = msg && msg.length > 0 ? msg : 'Something went wrong';
      this.toast(toastStatus, msgStr, true);
    }

  }


  confirmationCallbackModel = (id) => {
    // console.log('hello2')
    const { isReloadPage, redirectToList } = this.state;
    const { history } = this.props;
    this.setState({ enableToast: false }, () => {

      // console.log(isReloadPage);
      if (isReloadPage) {
        this.deleteRecord();
      }
      else if (redirectToList) {
        // console.log(history);
        history.push('/' + routes.mainRoute + '/' + routes.containers.admin + '/' + routes.admin.advertiser.newAdvertiser);
      }
    });
  }

  handleToastStatus = (status) => {
    // console.log('hello')
    const { facebookAds, redirectToList, isReloadPage } = this.state;
    const { history } = this.props;
    // console.log(isReloadPage);
    // console.log(toastMsg);
    this.setState({ enableToast: status }, () => {


      // console.log(isReloadPage);
      if (redirectToList) {
        // console.log(history);
        history.push('/' + routes.mainRoute + '/' + routes.containers.admin + '/' + routes.admin.advertiser.newAdvertiser);
      }
    });
  }

  // handle save details
  handleSubmit = () => {
    this.setState({ enableToast: true, confirmationMsg: "Kindly let us know if you'd like to save your changes." });
  }

  createAdvertiser = async (res) => {
    const { tenantId, authToken, userId, createAdvertiserAction, history, match, advertiserPayload } =
      this.props;
    const { form } = this.state;

    let finalData = res.map(item => {
      return { platform: "Google Adwords", accountList: [{ masterAccountId: item.masterId, accountId: item.customerId, currency: item.currencyCode, inex: 1 }] }
    })

    const {
      responseCode: { status = "", msg = "" },
      // responseList,
    } = await createAdvertiserAction({
      tenantId,
      authToken,
      userId,
      payload: {
        advertisersPlatforms: [{
          advertiser: JSON.parse(localStorage.getItem("advertiserId")),
          inex: 1,
          platforms: finalData
        }]
      },
    });

    if (status) {
      localStorage.removeItem("advertiserId");
      this.toast(status, msg);
    }
  }

  handleResync = async (ionList, index) => {
    let editId = JSON.parse(localStorage.getItem("editId"));
    const { postDv360CampaignAction, tenantId } = this.props;
    const { ionAds } = this.state;

    let obj = {
      customerId: ionList.accountId,
      masterId: ionList.masterAccountId,
      refreshToken: -1
    }

    var payload = {
      clientPartner: [obj]
    }

    if (payload.clientPartner.length > 0) {
      const { responseCode: { status = "" }, responseList } = await postDv360CampaignAction({ tenantId, payload });
      if (status == "Success" && responseList.length > 0) {
        let res = responseList[0].campaignDetails.map(camp => {
          return {
            label: camp.displayName,
            value: camp.displayName,
            name: camp.displayName,
            isActive: camp.isActive,
            isCampaignNew: camp.isCampaignNew,
            campaignId: camp.campaignId,
            entityStatus: camp.entityStatus,
            advertiserId: camp.advertiserId
          }
        })

        let obj = {
          customerId: responseList[0].customerId, masterId: responseList[0].masterId, currencyCode: responseList[0].currencyCode, isNew: 0, isMasterNew: 0, refreshToken: responseList[0].refreshToken, email: responseList[0].email, campaignDetails: res, advId: editId,
        }
        ionAds[index].campaignToggle = true;
        ionAds[index].campaigns = obj;
        ionAds[index].campaignSelected = res.filter((dataFilter) => dataFilter.isCampaignNew == 0)
        this.setState({ ionAds, campaignDetails: obj })
      }
    } else {
      this.setState({ enableToast: true, confirmationMsg: "Please Select A Account.", toastMsg: "", toastStatus: "required" });
    }
  }

  handleSyncSelect = (selected, index) => {
    const { ionAds } = this.state;
    ionAds[index].campaignSelected = selected;
    this.setState({ ionAds })
  }

  render() {
    const { options, paths, isAccountDV360 } = this.props;
    const RadioComponent = this.props.radioComponent;
    const { accToggle, campaignToggle, masterAccountToogle, masterAccounts, cardStatus, fetchAccount, campaignDetails, masterDisabled, accountDisabled, enableToast, toastStatus, toastMsg, confirmationMsg, campaignDetailsList, ionAds } = this.state;
    let Option = options.optionFun;
    let multiValue = options.multiValue;

    return (
      <>
        {
          enableToast && <ToastModal
            enableToast={enableToast}
            status={toastStatus}
            msg={toastMsg}
            // path={routes.containers.admin + "/" + routes.admin.advertiser.poc}
            idProps={paths}
            handleConfirmation={this.confirmationCallbackModel}
            handleToastStatus={this.handleToastStatus}
            confirmationMsg={confirmationMsg}
            outSideClickEnable={false}
            poc={true}
          />
        }




        {/* <div className='addBtn' style={{ textAlign: "right" }}>
          <button className='btn-add-io' style={{ marginTop: "0px", float: "none" }} onClick={() => this.handleAddClick()}><i className="mdi mdi-plus-box"></i>
          </button>
        </div> */}
        <button type="button" className="btn btn-primary" onClick={() => this.infoGenrateAccountID()} style={{position:'relative', }}>Generate Account Id</button>
      </>
    )
  }
}

export default withRouter(connect(state => ({
  configurationList: get(state, 'app.configurationData.responseList', []),
  ioAdvertisersReport: get(state, 'app.ioAdvertisersReport.responseList', []),
  tenantId: get(state, 'app.preSignInState.tenantId', ''),
  userId: get(state, 'app.preSignInData.userId', ''),
  authToken: get(state, 'app.signInData.authToken', ''),
  responseAdvertiser: get(state, 'app.preSignInData.responseList', []),
}), { postIonCampaignAction, postDV360VerificationAction, postDv360AccountsAction, postDv360CampaignAction, postSyncCampaignAction, getGenrateAccountIdDV360Action, getUserInformationAction, createAdvertiserAction, getDv360UrlAction, deleteAccountsAction, postSyncCampaignDV360Action })(index));